import {Record as record} from 'immutable';

export default record(
    {
        adults: 0,
        children: 0,
        bedrooms: 0,
        pets: false
    },
    'GuestSelectorRecord'
);
